import { AxiosError } from 'axios';
import { queryCache, QueryConfig, useQuery } from 'react-query';

import { __DEV__ } from '~src/config';
import {
  LoadSharedFoldersFoldersIdParams,
  loadSharedTenderFolderFiles,
} from '~src/services/api/shares';
import { DbAttachment } from '~src/types/db';

// type UseSharedFolderFilesParams = LoadSharedFoldersFoldersIdParams;

export const useSharedTenderFolderFiles = (
  loadFilesParams: LoadSharedFoldersFoldersIdParams,
  queryConfig: QueryConfig<DbAttachment[], AxiosError> & {
    enabled?: boolean;
    show_deleted?: boolean;
  } = {}
) => {
  const { enabled, show_deleted, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const filesQuery = useQuery<DbAttachment[], AxiosError>(
    [
      'sharedFolderFiles',
      {
        show_deleted,
        ...loadFilesParams,
      },
    ],
    loadSharedTenderFolderFiles,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite,
      // foldersReady &&
      // loadFilesParams.folderId !== 'undefined',
      refetchOnMount: false,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return filesQuery;
};
